import logo from "./picture/logo.jpg"
import van from "./picture/稿定设计-4.png"
import customer_service from "./picture/稿定设计-3.png"
import {Col, Row, Popover, Button} from "antd";


function Title() {
  const content = (
    <div>
      <p>
        赵先生：13051809155
      </p>
      <p>
        张小姐：13718254409
      </p>
    </div>
  )
  return (
    <>
      <div style={{width:"100%", textAlign:"center", display:"flex", justifyContent:"center",  position: "fixed", top: 0, backgroundColor:"white", zIndex:"1000"}}>
        <Row >
          <Col>
            <div >
              <img style={{marginRight:"1.5%",width:window.innerWidth*0.1, marginTop:window.innerWidth*0.02, marginLeft:"-2.9%"}} src={logo} alt="logo"/>
            </div>
          </Col>
          <Col>
            <div >
              <img style={{marginRight:"1.3%",width:window.innerWidth*0.01, opacity:"0"}} src={logo} alt="logo"/>
              <h1 style={{fontSize:window.innerWidth*0.031}}>中科心感（南京）医疗电子科技有限公司 </h1>
            </div>
          </Col>
          <Col>
            <div >
              <img  style={{marginLeft:"30.7%", height:"53%", width:window.innerWidth*0.046, marginTop:window.innerWidth*0.045}} src={van} alt=""/>
              <p style={{fontWeight:"bold", marginLeft:window.innerWidth*0.03, fontSize:window.innerWidth*0.02}}>快递包邮</p>
            </div>

          </Col>
          <Col >
            <div >
              <img  style={{marginLeft:"33%", height:"53%", width:window.innerWidth*0.046, marginTop:window.innerWidth*0.045}} src={customer_service} alt=""/>
              {/*<p style={{fontWeight:"bold", marginLeft:window.innerWidth*0.03, fontSize:window.innerWidth*0.02}}>咨询客服</p>*/}
              <p style={{fontWeight:"bold", marginLeft:window.innerWidth*0.03, marginTop:"0"}}>
                <Popover content={content} title="请添加微信或者直接拨打电话" trigger="click">
                  <Button style={{height:window.innerWidth*0.05 ,fontWeight:"bold", marginLeft:window.innerWidth*0.03, fontSize:window.innerWidth*0.02}}>联系客服</Button>
                </Popover>
              </p>
            </div>
          </Col>
        </Row>
      </div>


      <div style={{ width:"100%", textAlign:"center", margiLeft:"34%", display:"flex", justifyContent:"center" , backgroundColor:"DodgerBlue",  position: "fixed", top:window.innerWidth*0.14, zIndex:"1000"}}>
        <Row gutter={25} >
          <Col span={4}  >
            <div>
              <a href="#monitor_introduce"
                 style={{type:"text",  textAlign:"center", marginTop:"0.36%", fontSize:window.innerWidth*0.021, color:"white", marginLeft:"-325%"}}
              >首页</a>
            </div>
          </Col>
          <Col span={5} >
            <div>
              <a href="#monitor_introduce" style={{type:"text", marginLeft:"-225%", textAlign:"center", marginTop:"0.36%", fontSize:window.innerWidth*0.021, color:"white"}}>镇店之宝</a>
            </div>
          </Col>
          <Col span={5}>
            <div>
              <a href="#company_introduce" style={{type:"text", marginLeft:"-175%", textAlign:"center", marginTop:"0.66%", fontSize:window.innerWidth*0.021, color:"white"}}>公司介绍</a>
            </div>
          </Col>
          <Col span={5} >
            <div>
              <a href="#product_introduce" style={{type:"text", marginLeft:"-125%",textAlign:"center", marginTop:"0.36%", fontSize:window.innerWidth*0.021, color:"white"}}>产品介绍</a>
            </div>
          </Col>
          <Col span={5} >
            <div>
              <a href="#phone" style={{type:"text", marginLeft:"-80%",textAlign:"center", marginTop:"0.36%", fontSize:window.innerWidth*0.021, color:"white"}}>联系方式</a>
            </div>
          </Col>
        </Row>

      </div>

    </>
  )
}

export default Title;
